<script setup>
import { computed } from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({ assignment: { type: Object, default: null } });
const dates = [
  ["assignedAt", "Fecha de entrega"],
  ["confirmedByEmployeeAt", "Fecha de confirmación de entrega"],
  ["returnedAt", "Fecha de solicitud de devolución"],
  ["receivedBySystemsAt", "Fecha de recepción de la devolución"],
];
const dateFields = computed(() => dates
  .filter(([key]) => props.assignment?.[key])
  .map(([key, label]) => ({ key, label, value: formatDateTime(props.assignment[key]) })));

function formatDateTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = number => String(number).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
</script>

<template>
  <div v-if="assignment" class="row material-assignment-info">
    <div v-if="assignment.employee?.fullName" class="col-12 mt-3">
      <label class="w-100">Empleado al que se entrega</label>
      <el-input :model-value="assignment.employee.fullName" disabled class="w-100" />
    </div>
    <div v-for="field in dateFields" :key="field.key" class="col-md-6 col-12 mt-3">
      <label class="w-100">{{ field.label }}</label>
      <el-input :model-value="field.value" disabled class="w-100" />
    </div>
    <div v-if="assignment.returnedTo?.fullName" class="col-md-6 col-12 mt-3">
      <label class="w-100">Recogido por</label>
      <el-input :model-value="assignment.returnedTo.fullName" disabled class="w-100" />
    </div>
    <div v-if="assignment.returnReason" class="col-12 mt-3">
      <label class="w-100">Razón de devolución</label>
      <el-input :model-value="assignment.returnReason" type="textarea" :rows="4" disabled class="w-100" />
    </div>
  </div>
</template>

<style scoped>
.material-assignment-info {
  margin-left: 0;
  margin-right: 0;
}

@media (max-width: 767.98px) {
  .material-assignment-info > div {
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
